import { Routes } from '@angular/router';
import { authGuard } from '@core/services/guards/auth.guard';
import { deviceDetectionGuard } from '@core/services/guards/device-detection.guard';
import { MainLayoutComponent } from '@layout/components/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [deviceDetectionGuard, authGuard],
    children: [
      {
        path: 'companies',
        loadChildren: () => import('./company/company.routes').then((m) => m.companyRoutes),
      },
      {
        path: 'construction',
        loadChildren: () => import('./@construction/construction.routes').then((m) => m.constructionRoutes),
      },
      {
        path: '',
        redirectTo: 'construction/projects',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.routes').then((m) => m.userRoutes),
  },
  {
    path: 'mobile',
    loadComponent: () => import('./mobile/mobile.component').then((c) => c.MobileComponent),
  },
  {
    path: 'release-notes',
    canActivate: [authGuard],
    loadChildren: () => import('./@release-notes/release-notes.routes').then((m) => m.releaseNotesRoutes),
  },
  {
    path: 'print',
    canActivate: [authGuard],
    loadChildren: () => import('./@print/print.routes').then((m) => m.printRoutes),
  },
  {
    path: 'kiosk',
    loadChildren: () => import('./@kiosk/kiosk.routes').then((m) => m.kioskRoutes),
  },
  {
    path: 'video-wall',
    canActivate: [authGuard],
    loadChildren: () => import('./@video-wall/video-wall.routes').then((m) => m.videoWallRoutes),
  },
];
